module.exports = __webpack_public_path__ + "static/media/carnesyaves.fb85879d.svg";